import React, { useCallback, useImperativeHandle } from "react";
import { forwardRef } from "react";
import { useBoolean } from "ahooks";
import { Popup } from "antd-mobile";
import useDrawTraceMap, {
  DrawTraceMapProps,
} from "../../../../../../hooks/useDrawTraceMap";
import styles from "./index.module.scss";

export interface IMapPopupRef {
  open: (drawProps: DrawTraceMapProps) => void;
  close: () => void;
}

const MapPopup = forwardRef<IMapPopupRef>((props, ref) => {
  const [popupVisible, { setFalse: closePopup, setTrue: openPopup }] =
    useBoolean(false);
  const { containerId, drawTraceMap, hasMapInstance } = useDrawTraceMap();

  const open = useCallback(
    async (drawTraceMapProps) => {
      openPopup();
      if (!hasMapInstance()) {
        await drawTraceMap(drawTraceMapProps);
      }
    },
    [drawTraceMap, hasMapInstance, openPopup]
  );

  useImperativeHandle(
    ref,
    () => ({
      open: open,
      close: closePopup,
    }),
    [closePopup, open]
  );

  return (
    <Popup
      visible={popupVisible}
      onMaskClick={closePopup}
      onClose={closePopup}
      bodyStyle={{
        height: "80vh",
        borderTopLeftRadius: "24px",
        borderTopRightRadius: "24px",
        overflow: "hidden",
      }}
    >
      <div className={styles.myPopupContainer} id={containerId} />
    </Popup>
  );
});

export default MapPopup;
